<div id="dictionary">
  <mat-toolbar>
    <mat-toolbar-row>
      <span class="right-align"></span>
      <button class="navbar-icon" mat-icon-button (click)="close()">
        <i class="material-icons">
          close
        </i>
      </button>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <app-select-language
        [all]="false"
        [isLanId]="true"
        [selectedValue]="firstLanId"
        (selectionChanged)="firstLanguageChanged($event)"
      ></app-select-language>
      <app-select-language
        [all]="false"
        [isLanId]="true"
        [selectedValue]="secondLanId"
        (selectionChanged)="secondLanguageChanged($event)"
      ></app-select-language>
    </mat-toolbar-row>
  </mat-toolbar>
  <hr />
  <div class="table-container">
    <table>
      <thead></thead>
      <tbody>
        <tr>
          <th class="pointer left-align">{{ 'name' | translate }}</th>
        </tr>
        <tr>
          <td class="translation-column">
            <mat-form-field appearance="outline">
              <input
                matInput
                id="{{ entry?.id }}"
                type="text"
                value="{{ entry?.name }}"
                class="translation-column"
                maxlength="30"
                disabled="true"
              />
            </mat-form-field>
          </td>
          <td></td>
        </tr>
        <tr>
          <th class="pointer left-align">{{ firstLanText | translate }}</th>
        </tr>
        <tr>
          <td class="translation-column">
            <mat-form-field appearance="outline">
              <input
                matInput
                id="{{ entry?.id + '.' + entry?.first?.id + '.first' }}"
                type="text"
                value="{{ entry?.first?.text }}"
                class="translation-column"
              />
            </mat-form-field>
          </td>
          <td class="pointer" (click)="saveFirst(entry)">
            <button class="navbar-icon" mat-icon-button>
              <i class="material-icons">
                save
              </i>
            </button>
          </td>
        </tr>
        <tr>
          <th class="pointer left-align">{{ secondLanText | translate }}</th>
        </tr>
        <tr>
          <td class="translation-column">
            <mat-form-field appearance="outline">
              <input
                matInput
                id="{{ entry?.id + '.' + entry?.second?.id + '.second' }}"
                type="text"
                value="{{ entry?.second?.text }}"
                class="translation-column"
              />
            </mat-form-field>
          </td>
          <td class="pointer" (click)="saveSecond(entry)">
            <button class="navbar-icon" mat-icon-button>
              <i class="material-icons">
                save
              </i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
